import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const InquiryTrendChart = ({ monthlyData }) => {
  const data = {
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    datasets: [
      {
        label: "Closed Deal",
        data: monthlyData.closedDeals,
        backgroundColor: "#0073a5",
        borderRadius: 4,
      },
      {
        label: "Total Inquiries",
        data: monthlyData.totalInquiries,
        backgroundColor: "#00d0dc",
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: (value) => (value >= 1000 ? `${value / 1000}K` : value),
        },
      },
    },
    barThickness: 10,
  };

  return <Bar data={data} options={options} />;
};

export default InquiryTrendChart;
